<template>
  <AppLayout :title="`Venda #${id}`" back-to="sales">
    <template #actions>
      <button
        v-if="venda && !venda.canceled_at"
        type="button"
        class="btn btn-outline-danger"
        @click="openCancelModal()"
      >
        Cancelar venda
      </button>
    </template>

    <div v-if="!venda" class="text-muted">Carregando...</div>

    <div v-else>
      <div v-if="venda.canceled_at" class="alert alert-danger">
        Venda cancelada em {{ formaterService.dateTime(venda.canceled_at) }}
        <template v-if="venda.cancel_operator">por {{ venda.cancel_operator.name }}</template>.
      </div>

      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <strong>Cliente:</strong><br>
              {{ venda.customer?.name ?? 'Avulso' }}
            </div>
            <div class="col-md-3">
              <strong>Data:</strong><br>
              {{ formaterService.dateTime(venda.date) }}
            </div>
            <div class="col-md-3">
              <strong>Forma de pagamento:</strong><br>
              {{ venda.payment_method?.name ?? formaterService.payment(venda.payment) }}
            </div>
            <div class="col-md-3">
              <strong>Valor total:</strong><br>
              {{ formaterService.currency(venda.value) }}
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-3">
              <strong>Lucro (saldo):</strong><br>
              {{ formaterService.currency(venda.balance) }}
            </div>
            <div class="col-md-3">
              <strong>Operador:</strong><br>
              {{ venda.cashier?.operator?.name ?? '-' }}
            </div>
            <div class="col-md-3">
              <strong>Caixa:</strong><br>
              #{{ venda.cashier_id ?? '-' }}
            </div>
            <div class="col-md-3" v-if="venda.operation_bill">
              <strong>Lançado na conta do cliente:</strong><br>
              {{ formaterService.currency(venda.operation_bill.value) }}
            </div>
          </div>
        </div>
      </div>

      <h2 class="section-title">Produtos lançados</h2>
      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Preço unitário</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in venda.to_operation_products" :key="item.id">
              <td>{{ item.product?.name ?? ('Produto #' + item.product_id) }}</td>
              <td>{{ item.amount }} {{ item.product?.measure }}</td>
              <td>{{ formaterService.currency(item.price_uni) }}</td>
              <td>{{ formaterService.currency(item.price_total) }}</td>
            </tr>
            <tr v-if="!venda.to_operation_products?.length">
              <td colspan="4" class="text-center text-muted">Nenhum produto lançado nesta venda.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template v-if="venda.to_operation_services?.length">
        <h2 class="section-title">Serviços lançados</h2>
        <div class="table-card">
          <table class="table">
            <thead>
              <tr>
                <th>Serviço</th>
                <th>Quantidade</th>
                <th>Preço unitário</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in venda.to_operation_services" :key="item.id">
                <td>{{ item.service?.name ?? ('Serviço #' + item.service_id) }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ formaterService.currency(item.price_uni) }}</td>
                <td>{{ formaterService.currency(item.price_total) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </AppLayout>

  <!-- Modal Cancelar Venda -->
  <div class="modal fade" id="modal_cancelar_venda" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cancelar venda</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>
            Esta ação vai devolver os produtos ao estoque
            <template v-if="venda?.operation_bill">e reverter o lançamento na conta do cliente </template>
            e não pode ser desfeita. Confirme sua senha para continuar.
          </p>
          <div class="mb-3">
            <label for="inp_cancel_password" class="form-label">Senha:</label>
            <input
              id="inp_cancel_password"
              type="password"
              class="form-control"
              v-model="cancelPassword"
              @keyup.enter="confirmCancel()"
            >
          </div>
          <div v-if="cancelError" class="alert alert-danger py-2 mb-0">{{ cancelError }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Voltar</button>
          <button type="button" class="btn btn-danger" :disabled="cancelLoading" @click="confirmCancel()">
            {{ cancelLoading ? 'Cancelando...' : 'Cancelar venda' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppLayout from "@/components/AppLayout.vue";
import { Modal } from "bootstrap";
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { seles } from "@/models/seles";
import formaterService from "@/services/formaterService";

export default {
  name: 'SaleDetailView',
  components: {
    AppLayout
  },
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const venda = ref(null);
    const Vendas = seles();

    const cancelPassword = ref('');
    const cancelError = ref('');
    const cancelLoading = ref(false);
    let cancelModal = null;

    onMounted(async () => {
      venda.value = await Vendas.show(id);
    });

    function openCancelModal() {
      cancelPassword.value = '';
      cancelError.value = '';
      cancelModal = new Modal(document.getElementById('modal_cancelar_venda'));
      cancelModal.show();
    }

    async function confirmCancel() {
      if (!cancelPassword.value) {
        cancelError.value = 'Informe sua senha.';
        return;
      }
      cancelLoading.value = true;
      cancelError.value = '';
      const resultado = await Vendas.cancel(id, cancelPassword.value);
      cancelLoading.value = false;
      if (resultado.success) {
        venda.value = resultado.venda;
        cancelModal.hide();
      } else {
        cancelError.value = resultado.message;
      }
    }

    return {
      id, venda, formaterService,
      cancelPassword, cancelError, cancelLoading,
      openCancelModal, confirmCancel,
    }
  },
}
</script>
<style scoped>
.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-strong);
  margin-bottom: 0.75rem;
}
</style>
